// 首页 Hero 分栏行适配
import { parseHeroPercent } from '@/components/home/utils/heroTextBlocks'
import { HERO_MEDIA_FIT, normalizeMediaFit } from '@/components/home/utils/heroColumnRows'

const META_PREFIX = '__HERO_ROW_FIT:'
const META_SUFFIX = '__'
const META_TEXT = '\u200b'

/** 生成用于存储行 mediaFit 的隐藏 fontFamily 标识 */
export function heroRowFitMetaFamily(fit) {
  return `${META_PREFIX}${normalizeMediaFit(fit)}${META_SUFFIX}`
}

/** 从 fontFamily 解析出行 mediaFit 元数据，非元数据返回 null */
export function parseHeroRowFitMetaFamily(fontFamily) {
  const value = String(fontFamily || '')
  if (!value.startsWith(META_PREFIX) || !value.endsWith(META_SUFFIX)) return null
  return normalizeMediaFit(value.slice(META_PREFIX.length, -META_SUFFIX.length))
}

/** 判断文字条目是否为行 mediaFit 隐藏元数据 */
export function isHeroRowFitMetaEntry(entry) {
  return parseHeroRowFitMetaFamily(entry?.fontFamily) != null
}

/** 计算行级元数据文字的全局纵向位置 */
export function rowGlobalMetaPosY(rowIndex, rowCount) {
  if (rowCount <= 1) return '5%'
  return rowIndex === 0 ? '5%' : '55%'
}

/** 构建携带 mediaFit 信息的不可见元数据文字条目 */
export function buildRowFitMetaText(rowIndex, rowCount, fit, locale = 'zh-CN') {
  return {
    locale,
    text: META_TEXT,
    posX: '0%',
    posY: rowGlobalMetaPosY(rowIndex, rowCount),
    color: 'rgba(0,0,0,0)',
    fontSize: '1px',
    fontWeight: 'normal',
    fontFamily: heroRowFitMetaFamily(fit),
    textAlign: 'left'
  }
}

/** 从文字列表中提取首个 mediaFit 元数据值 */
export function extractMediaFitFromTexts(texts = []) {
  for (const entry of texts) {
    const fit = parseHeroRowFitMetaFamily(entry?.fontFamily)
    if (fit) return fit
  }
  return null
}

/** 移除文字列表中的 mediaFit 隐藏元数据条目 */
export function stripHeroRowFitMetaTexts(texts = []) {
  return (texts || []).filter((entry) => !isHeroRowFitMetaEntry(entry))
}

/** 为每行解析 mediaFit 并剥离元数据文字 */
export function applyRowTextMeta(rows, rowCount) {
  return (rows || []).map((row, rowIndex) => {
    const mediaFit = normalizeMediaFit(
      row.mediaFit || extractMediaFitFromTexts(row.texts)
    )
    return {
      ...row,
      mediaFit,
      texts: stripHeroRowFitMetaTexts(row.texts)
    }
  })
}

/** 按 posY 将文字拆分到上下两行（双行 COLUMN 布局用） */
export function splitTextsToRowsWithMeta(texts, rowCount) {
  if (rowCount <= 1) {
    return [texts || []]
  }

  const rows = [[], []]
  ;(texts || []).forEach((entry) => {
    const globalY = parseHeroPercent(entry.posY)
    const rowIndex = globalY >= 50 ? 1 : 0
    rows[rowIndex].push({ ...entry })
  })
  return rows
}
